import { render, staticRenderFns } from "./order_collection.vue?vue&type=template&id=fa95dcb4"
import script from "./order_collection.vue?vue&type=script&lang=js"
export * from "./order_collection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa95dcb4')) {
      api.createRecord('fa95dcb4', component.options)
    } else {
      api.reload('fa95dcb4', component.options)
    }
    module.hot.accept("./order_collection.vue?vue&type=template&id=fa95dcb4", function () {
      api.rerender('fa95dcb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/visit_manage/visit_detail/components/order_collection.vue"
export default component.exports